import currency from "slotworks/i18n/currency";
import translations from "slotworks/i18n/translations";
import betModel from "slotworks/model/bets/bet-model";
import AbstractTextControl from "slotworks/smart-ui/controls/abstract/abstract-text-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";

export class SGPaytablePage1TextControl extends AbstractTextControl implements Control {
    public updateOptions(options: ControlOptions): void {
        const totalStake: string = currency.format(betModel.getTotalStake());
        this.text.setText(translations.get("pt1.con", { totalstake: totalStake }));
    }
}
